<template>
  <el-tooltip theme="light" effect="light">
    <img
      :src="attrs.fieldTypeText === '文本' ? require(`@/assets/img/text.png`) : attrs.fieldTypeText === '数值' ? require(`@/assets/img/number.png`) : attrs.fieldTypeText === '日期' ? require(`@/assets/img/date.png`) : require(`@/assets/img/datetime.png`)"
      alt="">
      <div slot="content" style="width:200px">
        <div>字段类型：{{ attrs.fieldTypeText }}</div>
        <div>
          <span>字段属性：</span>
          <span v-if="attrs.fieldLength">长度{{ attrs.fieldLength }}</span>
          <span v-if="attrs.fieldPrecision"> 精度{{ attrs.fieldPrecision }}</span>
        </div>
        <div>字段说明：{{ attrs.fieldDesc || '-' }}</div>
      </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    attrs: {
      type: Object,
      default: () => ({})
    },
  }
}
</script>